import { Row, Col } from "antd";
import AddStaffForm from "components/form/Staff/Add";
import { useFetchLocalStorage } from "lib/useFetchLocalStorage";
import useUser from "lib/useUser";

function AddStaff() {
  useFetchLocalStorage();
  useUser({ redirectTo: "/login" });

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} md={10}>
        <div className="info">
          <h3>Staff Data</h3>
          <p>Please fill in all new information to add new staff.</p>
        </div>
      </Col>
      <Col xs={24} md={14}>
        <AddStaffForm />
      </Col>
    </Row>
  );
}

export default AddStaff;
